var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { InputLabel } from "@material-ui/core";
import Select from "react-select";
var DropdownWithCheckBox = /** @class */ (function (_super) {
    __extends(DropdownWithCheckBox, _super);
    function DropdownWithCheckBox(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelectBoxChange = function (selected) {
            _this.setState({ selectedValue: selected });
            _this.props.handleSelectBox(selected);
        };
        _this.state = {
            isChecked: _this.props.defaultCheck,
            selectedValue: _this.props.selectedValue,
        };
        return _this;
    }
    DropdownWithCheckBox.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.selectedValue != this.props.selectedValue) {
            this.setState({ selectedValue: nextProps.selectedValue });
        }
    };
    DropdownWithCheckBox.prototype.render = function () {
        var _this = this;
        return (_jsx("div", __assign({ style: { width: "106%" } }, { children: _jsxs("div", __assign({ style: { width: "50%", float: "left" } }, { children: [_jsx(InputLabel, __assign({ style: { transform: "translate(0, -0.25px) scale(0.75)" } }, { children: this.props.selectBoxLabel })), _jsx(Select, { value: this.state.selectedValue, onChange: function (e) {
                            _this.handleSelectBoxChange(e);
                        }, options: this.props.selectBoxOptions, searchable: true, placeholder: this.props.placeHolderText, className: "clientLedgerDropdownColor" })] })) })));
    };
    return DropdownWithCheckBox;
}(React.Component));
export { DropdownWithCheckBox };
